import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoTableColumn, } from '@po-ui/ng-components';
import { Transportadora } from 'src/app/interface/transportadora';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { defaultPedidoLote, defaultRomaneioClienteDto, PedidoLote, RomaneioClienteDto, RomaneioClienteItem } from '../../romaneio/interface/romaneio';
import { Veiculo } from '../../romaneio/interface/veiculo';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { VeiculoLookupService } from '../../romaneio/service/veiculo-lookup-service';
import { AuthService } from 'src/app/service/auth.service';
import { Cliente } from 'src/app/interface/cliente';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';

@Component({
  selector: 'app-romaneio-mercado-interno-cadastro',
  templateUrl: './romaneio-mercado-interno-cadastro.component.html',
  styleUrls: ['./romaneio-mercado-interno-cadastro.component.css']
})
export class RomaneioMercadoInternoCadastroComponent implements OnInit {

  codigoRomaneio: string = '';
  romaneioCliente: RomaneioClienteDto;
  alteraRomaneio: RomaneioClienteDto;

  etiqueta: string = '';
  loteExclusao: string = '';
  apareceInformacoes: boolean = false;

  poNumber: string = '';
  filtroItens: string = '';
  filtroStatus: string = '';

  bloqueiaPlaca: boolean = false;

  contadorItem: number = 1;

  podeAvancar: boolean = true;

  permissaoExpedicao: boolean = true;
  permissaoComercial: boolean = true;
  permissaoFaturamento: boolean = true;

  pedidosFiltradosHelp: Array<PedidoLote> = [];
  pedidosFiltrados: Array<PedidoLote> = [];

  veiculoAdvancedFilters: Array<PoDynamicFormField>;
  veiculoColumnsFilters: Array<PoLookupColumn>;
  veiculoFieldFormaterFilters: (value: Veiculo) => string;

  advancedTransportadoraFilters: Array<PoDynamicFormField>;
  columnsTransportadoraFilters: Array<PoLookupColumn>;
  fieldFormaterTransportadoraFilters: ((value: Transportadora) => string);

  advancedClienteFilters: Array<PoDynamicFormField>;
  columnsClienteFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  codCliente: string = "";

  filterCliente: any;

  constructor(
    private romaneioService: RomaneioService,
    private route: ActivatedRoute,
    private poDialogService: PoDialogService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    public veiculoLookupService: VeiculoLookupService,
    public transportadoraService: TransportadoraService,
    public clienteLookupService: ClienteLookupService,
    private authService: AuthService,

  ) {
    this.romaneioCliente = defaultRomaneioClienteDto();
    this.alteraRomaneio = defaultRomaneioClienteDto();

    this.veiculoAdvancedFilters      = this.veiculoLookupService.getAdvancedFilter();
    this.veiculoColumnsFilters       = this.veiculoLookupService.getColumnsFilter();
    this.veiculoFieldFormaterFilters = this.veiculoLookupService.getFieldFormater;

    this.advancedTransportadoraFilters = this.transportadoraService.getAdvancedFilter();
    this.columnsTransportadoraFilters = this.transportadoraService.getColumnsFilter();
    this.fieldFormaterTransportadoraFilters = this.transportadoraService.getFieldFormater;

    this.advancedClienteFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsClienteFilters = this.clienteLookupService.getColumnsCompletaFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;

  }

  @ViewChild('alteraDadosModal', { static: true }) alteraDadosModal!: PoModalComponent;
  @ViewChild('gerarPedidoModal', { static: true }) gerarPedidoModal!: PoModalComponent;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if ('CZ00COD' in params) {
        this.codigoRomaneio = params['CZ00COD'];

        this.loadDados();

        this.authService.validaPrivilegio(["PO_EXPEDICAO", "PORTAL_ADMINISTRADOR"]).then((ret) => {
          this.permissaoExpedicao = ret;
        });

        this.authService.validaPrivilegio(["PO_COMERCIAL", "PORTAL_ADMINISTRADOR"]).then((ret) => {
          this.permissaoComercial = ret;
        });

        this.authService.validaPrivilegio(["PO_FATURAMENTO", "PORTAL_ADMINISTRADOR"]).then((ret) => {
          this.permissaoFaturamento = ret;
        });

      }
    });
  }

  goTo(): void {
    this.router.navigateByUrl('');
  }

  loadDados(): void {
    this.podeAvancar = true;
    this.romaneioService.getRomaneioCliente(this.codigoRomaneio).subscribe(romaneio => {
      this.romaneioCliente = romaneio;
      if (this.romaneioCliente.CZ00CLIENT == '') {
        this.podeAvancar = false;
      } else {
        this.romaneioCliente.itemsSelecionados.map((item) => {
          if (item.CZ02PEDIDO != this.romaneioCliente.CZ00PEDGER) {
            this.podeAvancar = false;
          }
        });
      }
      this.filterCliente = {CA1GRPVEN: this.romaneioCliente.CZ00GRPVEN};
      this.alteraRomaneio = romaneio;
      this.romaneioCliente.itemsSelecionados = this.romaneioCliente.itemsSelecionados.map((item) => {
        item.contador = this.contadorItem;
        this.contadorItem += 1;
        return {...item, favorite: ['excluir']};
      })
      this.romaneioCliente.pedidos = this.romaneioCliente.pedidos.map((pedido) => {
        let vinc = 0;
        let contador = 1;
        pedido.lotes = pedido.lotes.map((lote) => {
          lote.contador = contador;
          lote.status = 'P';
          if (lote.NZ01QUANT == lote.NQTDVINCROMANEIO) {
            lote.status = 'R';
            vinc++;
            this.poNumber = pedido.CEE7PEDIDO;
          } else if (lote.NZ01QUANT == lote.NQTDVINCTOTAL) {
            lote.status = 'V';
            vinc++;
          }
          contador += 1;
          return {...lote};
        });
        pedido.status = 'P';
        if (vinc == pedido.lotes.length) {
          pedido.status = 'T';
        } else if (vinc > 0) {
          pedido.status = 'V';
        }
        return {...pedido};
      });
      this.pedidosFiltradosHelp = this.romaneioCliente.pedidos;
      this.pedidosFiltrados = this.romaneioCliente.pedidos;

      if ((this.romaneioCliente.CZ00STATUS === '3' || this.romaneioCliente.CZ00STATUS === '4') ) {
        this.bloqueiaPlaca = true;
      } else {
        this.bloqueiaPlaca = false;
      }
    }, (e) => {
      this.poDialogService.alert({
        title: 'ATENÇÃO',
        message: 'Romaneio Cliente Inválido.',
        ok: () => this.goTo()
      });
    });
  }

  goToLista(): void {
    this.router.navigateByUrl('/estoque/expedicao/romaneio-mi');
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Romaneio Cliente', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Editar Romaneio' }
    ]
  };

  public readonly actions: Array<PoPageAction> = [
    { label: 'Atualizar Status', action: this.modalAtualizarStatusOpen.bind(this), disabled: this.desabilitaAtualizarStatus.bind(this) },
    { label: 'Alterar Dados', action: this.alterarDados.bind(this), disabled: this.desabilitaAlterarDados.bind(this)},
    { label: 'Liberar Pedido', action: this.liberarPedido.bind(this), disabled: this.desabilitaLiberarPedido.bind(this)},
  ];

  public readonly colunasPedidos: Array<PoTableColumn> = [
    {
      property: 'status',
      type: 'label',
      width: '10%',
      labels: [
        { value: 'P', color: 'color-01', label: 'Pendente' },
        { value: 'V', color: 'color-08', label: 'Parc Atendido' },
        { value: 'T', color: 'color-11', label: 'Atendido' },
      ]
    },
    { property: 'CEE7PEDIDO' , visible: true , label: 'Ordem' },
    { property: 'CC5CLIENTE' , visible: true , label: 'Cliente' },
    { property: 'CC5LOJACLI' , visible: true , label: 'Loja' },
    { property: 'CZ02PEDIDO' , visible: true , label: 'Pedido' },
    { property: 'lotes', label: 'Details', type: 'detail',
      detail: {
        columns: [
          {property: 'contador', label: 'Clas.' },
          {property: 'status', label: 'Status' },
          {property: 'CZ02PEDIDO', label: 'Pedido'},
          {property: 'CZ02LOTE', label: 'Lote'},
          {property: 'CB1COD', label: 'Produto'},
          {property: 'CB1DESC', label: 'Descrição'},
          {property: 'CZ00DATA', label: 'Data'},
          {property: 'CZ02INFORM', label: 'T ou E'},
          {property: 'CZ02UR', label: 'UR'},
          {property: 'NZ01QUANT', label: 'Qtd Lote'},
          {property: 'NSOMAQTDVEN', label: 'Qtd Pedido'},
          {property: 'NQTDVINCROMANEIO', label: 'Qtd Vinc Romaneio'},
          {property: 'NQTDVINCTOTAL', label: 'Qtd Vinc Total'},
          {property: 'NSOMAQTDENT', label: 'Qtd Entregue'},
          {property: 'NZ02PESO', label: 'Peso'},
          {property: 'CZ02PRAT', label: 'Prateleira'},
          {property: 'CZ02NPACOT', label: 'Pacote'},
          {property: 'NZ02CTNR', label: 'Nro. Container'},
        ],
        typeHeader: 'top'
      }
    }
  ];

  public readonly colunasSelecionados: Array<PoTableColumn> = [
    {property: 'contador', label: 'Clas.'},
    {property: 'CZ02PEDIDO', label: 'Pedido'},
    {property: 'CZ02LOTE', label: 'Lote'},
    {property: 'CB1COD', visible: false, label: 'Produto'},
    {property: 'CB1DESC', label: 'Descrição'},
    {property: 'CZ02INFORM', label: 'T ou E'  , width: '8%', type: 'label',
      labels: [
        { value: 'T', color: 'color-01',  label: 'Toco'     },
        { value: 'E', color: 'color-05',  label: 'Esqui'    },
      ]
    },
    {property: 'CZ02UR', label: 'UR'},
    {property: 'NZ01QUANT', label: 'Quantidade'},
    {property: 'NZ02PESO', label: 'Peso'},
    {property: 'CZ02PRAT', label: 'Prateleira'},
    {property: 'NZ02CTNR', label: 'Nro. Container'},
    {property: 'favorite'  , label: '...'             , width: '10%' ,type: 'icon',
      icons: [
        {
          action: this.openDialogConfirmarExcluirItem.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir',
          value: 'excluir',
          disabled: this.desabilitaExcluir.bind(this)
        }
      ]
    }

  ];

  alterarDados(): void {
    this.alteraDadosModal.open();
  }

  public readonly salvarDadosRomaneio: PoModalAction = {
    action: () => {
      this.romaneioService.alterarDadosRomaneioCliente(this.alteraRomaneio).subscribe((ret) => {
        this.alteraDadosModal.close();
        this.loadDados();
      })
    },
    label: 'Salvar',
  };

  modalAtualizarStatusOpen(): void {
    let cvalorTotal = '';
    let cTxtMsg = 'Deseja realmente faturar o Romaneio Cliente?';

    if (this.romaneioCliente.CZ00STATUS == "2") {
      this.romaneioService.valorTotalRomaneio(this.romaneioCliente.itemsSelecionados[0].CZ02PEDIDO).subscribe((ret) => {
        cvalorTotal = ret.CTOTROMANEIO;
        if (cvalorTotal != '0,0' ) {
          cTxtMsg = `O Valor aproximado da NF será de R$ ${cvalorTotal}. Deseja realmente faturar o Romaneio Cliente?`
        }
        this.poDialogService.confirm({
          title: 'Faturar',
          message: cTxtMsg,
          confirm: () => this.atualizarStatus()
        });
      })
    } else {
      this.atualizarStatus()
    }
  }
  desabilitaAtualizarStatus(): boolean {
    let lret = true;

    if (!this.podeAvancar) {
      return true;
    }

    if (this.romaneioCliente.CZ00STATUS == "0" && this.permissaoExpedicao ) {
      lret = false;
    } else if (this.romaneioCliente.CZ00STATUS == "1" && this.permissaoComercial ) {
      lret = false;
    }
    else if ((this.romaneioCliente.CZ00STATUS == "2" || this.romaneioCliente.CZ00STATUS == "3"|| this.romaneioCliente.CZ00STATUS == "5" ) && this.permissaoFaturamento ) {
      lret = false;
    }

    return lret;
  }

  desabilitaAlterarDados(): boolean {
    return this.romaneioCliente.CZ00STATUS == "Z";
  }

  desabilitaLiberarPedido(): boolean {
    return this.romaneioCliente.CZ00STATUS != "1" || !this.permissaoComercial || this.romaneioCliente.itemsSelecionados.length == 0;
  }

  getPdfRomaneio(): void {
    this.romaneioService.getPdfRomaneio(this.romaneioCliente.CZ00COD).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${this.romaneioCliente.CZ00COD}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  atualizarStatus(): void {
    this.romaneioService.atualizarStatusRomaneioCliente(this.romaneioCliente).subscribe(() => {
      this.poNotificationService.success("Status atualizado com sucesso!");
      if (this.romaneioCliente.CZ00STATUS == "2") {
        this.getPdfRomaneio();
      }
      this.loadDados();
    });
  }

  liberarPedido(): void {
    let uniqueValues = [
      ...new Set(this.romaneioCliente.itemsSelecionados.map((element) => element.CZ02PEDIDO)),
    ];
    if (uniqueValues.length > 1) {
      this.poNotificationService.information("Não é possível realizar a liberação via portal, pois os itens do romaneio não pertencem ao mesmo pedido.");
    } else {
      this.router.navigateByUrl(`/estoque/romaneio/liberacao-pedido/MI/${this.codigoRomaneio}/${this.romaneioCliente.itemsSelecionados[0].CZ02PEDIDO}`);
    }
  }

  selectLinha(row: PedidoLote): void {
    //@ts-ignore
   if (row.lotes?.length) {
      for (const item of row.lotes){
        //@ts-ignore
        item.$selected = row.$selected;
      }
    }
  }

  adicionarItensRomaneio(): void {
    let pedidoLote: PedidoLote = defaultPedidoLote();

    let pesoJaUtilizado = 0;
    let pesoNovosSelecionados = 0;
    this.romaneioCliente.itemsSelecionados.map((selecionado) => {
      pesoJaUtilizado +=  selecionado.NZ02PESO;
    });

    for (const item of this.pedidosFiltrados) {
      for (const lote of item.lotes) {
        //@ts-ignore
        if (lote.$selected) {
          if (lote.status == 'P') {
            pedidoLote.lotes.push(lote);
          }
        }
      }
    }

    pedidoLote.lotes.map((loteSelecionado) => {
      pesoNovosSelecionados += loteSelecionado.NZ02PESO;
    })

    let pesoTotal = pesoNovosSelecionados+pesoJaUtilizado
    if (pesoTotal <= this.romaneioCliente.NZ00PESLIM) {

      pedidoLote.CTIPO = 'MI';

      this.romaneioService.adicionarItensRomaneioCliente(this.romaneioCliente.CZ00COD, pedidoLote).subscribe(() => {
        for (const item of this.pedidosFiltrados) {
          let cont = 0;
          for (const lote of item.lotes) {
            //@ts-ignore
            if (lote.$selected) {
              if (this.poNumber == '' || this.poNumber == item.CEE7PEDIDO) {
                this.poNumber = item.CEE7PEDIDO;
                if (lote.status == 'P') {
                  this.romaneioCliente.itemsSelecionados.push({...lote, favorite: ['excluir']});
                  lote.contador = this.contadorItem;
                  this.contadorItem += 1;
                  lote.status = 'R';
                  lote.NQTDVINCROMANEIO = lote.NZ01QUANT;
                  lote.NQTDVINCTOTAL = lote.NZ01QUANT;
                  this.podeAvancar = false;
                }
              } else {
                this.romaneioService.removerEtiqueta(this.codigoRomaneio, lote.CZ02LOTE).subscribe((e) => {
                  this.poNotificationService.error(`Não foi possível adicionar o lote ${lote.CZ02LOTE}, pois este Romaneio já possui itens com outro P.O. Number.`);
                });
              }
            }
            if (lote.status == 'R' || lote.status == 'V') {
              item.status = 'V';
              cont++;
            }
          }
          if (cont == item.lotes.length) {
            item.status = 'T';
          }
        }
      });
    } else {
      this.poNotificationService.error(`O peso total não pode ultrapassar o peso limite de ${this.romaneioCliente.NZ00PESLIM}`);
    }
  }

  clickInformacoes(): void {
    this.apareceInformacoes = !this.apareceInformacoes;
  }

  openDialogConfirmarExcluirItem(row: RomaneioClienteItem): void {
    this.poDialogService.confirm({
      title: 'Excluir Item',
      message: this.romaneioCliente.CZ00PEDGER == '' || this.romaneioCliente.CZ00PEDGER != row.CZ02PEDIDO ? 'Deseja realmente excluir o item?' : 'Deseja Realmente excluir o item? O pedido será regerado automaticamente.',
      confirm: () => this.excluirItem(row)
    });
  }

  excluirItem(row: RomaneioClienteItem): void {
    this.loteExclusao = row.CZ02LOTE;
    this.romaneioService.removerEtiqueta(this.codigoRomaneio, row.CZ02LOTE).subscribe( () => {
      if (this.romaneioCliente.CZ00PEDGER == '' || this.romaneioCliente.CZ00PEDGER != row.CZ02PEDIDO) {
        this.loadDados();
      } else {
        this.romaneioCliente.itemsSelecionados = this.romaneioCliente.itemsSelecionados.filter((item) => {
          return item.CZ02LOTE != row.CZ02LOTE;
        });
        this.gerarPedidoUnico(true);
      }
    });
  }

  desabilitaExcluir(row: RomaneioClienteItem): boolean {
    return this.romaneioCliente.CZ00STATUS == '3' || this.romaneioCliente.CZ00STATUS == 'Z' || !this.permissaoExpedicao;
  }

  filtrarPedidos(): void {
    this.pedidosFiltradosHelp = this.romaneioCliente.pedidos;

    if (this.filtroItens != '') {
      for (let i=0; i < this.pedidosFiltradosHelp.length; i++) {
        this.pedidosFiltradosHelp[i].lotes = this.pedidosFiltradosHelp[i].lotes.filter((lote) => {
          return lote.CZ02PEDIDO.includes(this.filtroItens) ||
          this.pedidosFiltradosHelp[i].CEE7PEDIDO.includes(this.filtroItens) ||
          lote.CZ02LOTE.includes(this.filtroItens) ||
          lote.CB1COD.includes(this.filtroItens) ||
          lote.CB1DESC.includes(this.filtroItens) ||
          lote.CZ02PRAT.includes(this.filtroItens) ||
          lote.CZ02UR.includes(this.filtroItens)
        });
      }

      this.pedidosFiltrados = this.pedidosFiltradosHelp.filter((item) => {
        return item.lotes.length > 0;
      });
    } else {
      this.pedidosFiltrados = this.romaneioCliente.pedidos;
    }

    if (this.filtroStatus == 'NV') {
      for (let i=0; i < this.pedidosFiltradosHelp.length; i++) {
        this.pedidosFiltradosHelp[i].lotes = this.pedidosFiltradosHelp[i].lotes.filter((lote) => {
          return lote.status != 'V';
        });
      }

      this.pedidosFiltrados = this.pedidosFiltradosHelp.filter((item) => {
        return item.lotes.length > 0;
      });
    }
  }

  acaoGerarPedidoUnico(): void {
    this.gerarPedidoModal.open();
  }

  clienteSelecionado(row: Cliente): void {
    this.romaneioCliente.CZ00CLIENT = row.CA1COD;
    this.romaneioCliente.CZ00LOJA = row.CA1LOJA;
  }

  public readonly gerarPedidoUnicoAction: PoModalAction = {
    action: () => {
      this.gerarPedidoModal.close();
      this.gerarPedidoUnico(false);
    },
    label: 'Confirmar'
  };

  gerarPedidoUnico(deletar: boolean): void {
    if (deletar) {
      this.romaneioCliente.CDELETAR = 'S';
      this.romaneioCliente.CLOTEEXCLUSAO = this.loteExclusao;
    }
    this.romaneioService.postGerarPedidoMI(this.romaneioCliente).subscribe((ret) => {
      this.loadDados();
    });
  }

}

